export type RequestQueueBucket = 'attention' | 'in_progress' | 'history' | 'neutral';
export type RequestQueueTone = 'danger' | 'warning' | 'success' | 'neutral';

export const getRequestQueueFilterTabClasses = (
  tone: RequestQueueTone,
  count: number,
  isActive: boolean
): string => {
  if (isActive) {
    if (tone === 'danger') {
      return 'bg-status-error-500/10 text-primary-light-100';
    }
    if (tone === 'warning') {
      return 'bg-status-warning-500/10 text-primary-light-100';
    }
    if (tone === 'success') {
      return 'bg-status-success-500/10 text-primary-light-100';
    }
    return 'bg-primary-light-300/8 text-primary-light-100';
  }

  if (count === 0) {
    return 'text-primary-light-500 hover:bg-primary-dark-100/18 hover:text-primary-light-400';
  }

  return 'text-primary-light-300 hover:bg-primary-dark-100/18 hover:text-primary-light-100';
};

export const getRequestQueueFilterActiveRailClasses = (bucket: RequestQueueBucket): string => {
  if (bucket === 'attention') {
    return 'bg-status-error-500';
  }
  if (bucket === 'in_progress') {
    return 'bg-status-warning-500';
  }
  if (bucket === 'history') {
    return 'bg-status-success-500';
  }
  return 'bg-primary-dark-300';
};

export const getRequestQueueFilterCountClasses = (
  tone: RequestQueueTone,
  count: number,
  isActive: boolean
): string => {
  if (!isActive) {
    return count === 0 ? 'text-primary-light-500' : 'text-primary-light-100';
  }

  if (tone === 'danger') {
    return 'text-status-error-100';
  }
  if (tone === 'warning') {
    return 'text-status-warning-100';
  }
  if (tone === 'success') {
    return 'text-status-success-100';
  }
  return 'text-primary-light-100';
};

export const getRequestQueueCardShellClasses = (bucket?: RequestQueueBucket): string => {
  if (bucket === 'attention') {
    return 'rs-request-queue-card--attention';
  }
  if (bucket === 'in_progress') {
    return 'rs-request-queue-card--in-progress';
  }
  if (bucket === 'history') {
    return 'rs-request-queue-card--history';
  }
  return 'rs-request-queue-card--neutral';
};
